<template>
  <div
    class="rounded-xl border border-gray-300 relative p-4 flex flex-col justify-between gap-8"
  >
    <div class="grid gap-3">
      <h4 class="font-sans font-medium text-2xl">
        {{ paper.Name }}
      </h4>
      <p class="text-black text-sm">
        {{ paper.MetaDescription }}
      </p>
    </div>
    <div>
      <div class="flex flex-row-reverse gap-5 justify-between mb-1">
        <span
          v-if="inWaitingPeriod"
          class="text-right text-gray-600 font-sans text-sm font-medium"
          >{{ $t('yourTrialIsOver') }}</span
        >
        <span
          v-else
          class="text-right text-blue font-sans text-sm font-medium"
          >{{ $t('14DayFreeTrial') }}</span
        >
        <span
          v-if="discount > 0"
          class="text-right text-red font-sans text-sm font-medium"
          >{{
            $t('saveAmountPercentage', {
              amount: Math.round(discount * 100),
            })
          }}</span
        >
      </div>
      <div class="flex items-center justify-between space-x-5">
        <div class="grid gap-1">
          <div class="flex flex-row items-end gap-1">
            <span class="font-sans font-medium text-3xl leading-none">{{
              $formatCurrency(Math.ceil((amountPerYear / 12) * (1 - discount)))
            }}</span>
            <div class="flex flex-col-reverse">
              <span class="text-base leading-none pb-1"> per måned</span>
              <span
                class="text-sm text-gray-600 line-through leading-none"
                :class="{ 'opacity-0': discount <= 0 }"
                >{{ $formatCurrency(Math.ceil(amountPerYear / 12)) }}</span
              >
            </div>
          </div>
          <span class="text-sm text-gray-600 font-medium font-sans"
            >{{ $t('YearlyPayment') }}
            {{
              $formatCurrency(Math.round(amountPerYear * (1 - discount)))
            }}</span
          >
        </div>
        <div class="grid gap-4">
          <div class="ml-auto">
            <CommonButton
              v-if="selected"
              bg="bg-gray-300"
              text="text-black"
              border="border-none"
              bg-hover="hover:bg-gray-200"
              @click.native="handleSelect"
            >
              {{ $t('Choosen') }}
            </CommonButton>
            <CommonButton
              v-else
              border="border-none"
              bg="bg-blue"
              text="text-white"
              text-hover="hover:text-white"
              bg-hover="hover:bg-denimblue"
              @click.native="handleSelect"
            >
              {{ $t('Choose') }}
            </CommonButton>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="hasAccess"
      class="rounded-xl bg-white bg-opacity-90 absolute top-0 left-0 w-full h-full flex flex-col items-center justify-center text-center p-4 gap-2"
    >
      <img class="w-8 h-8 inline-block" src="~assets/icons/checkmark.svg?url" />
      <span class="text-lg font-medium text-blue font-sans">{{
        $t('youAlreadyHaveAccessTo', { product: `Altinget ${paper.Name}` })
      }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ContentPaper } from '~/typesManual/content_api/paper'

const props = withDefaults(
  defineProps<{
    paper: ContentPaper
    amountPerYear: number
    selected?: boolean
    hasAccess?: boolean
    inWaitingPeriod?: boolean
    discount?: number
  }>(),
  {
    discount: 0,
  }
)

const emit = defineEmits<{
  (e: 'select', value: boolean): void
}>()

function handleSelect() {
  emit('select', !props.selected)
}
</script>
